import { render, staticRenderFns } from "./Button_Config.vue?vue&type=template&id=5caf66a7&"
import script from "./Button_Config.vue?vue&type=script&lang=js&"
export * from "./Button_Config.vue?vue&type=script&lang=js&"
import style0 from "./Button_Config.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCheckbox,VDataTable})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5caf66a7')) {
      api.createRecord('5caf66a7', component.options)
    } else {
      api.reload('5caf66a7', component.options)
    }
    module.hot.accept("./Button_Config.vue?vue&type=template&id=5caf66a7&", function () {
      api.rerender('5caf66a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Multifunction/Button_Config.vue"
export default component.exports